import { Currency, Ether, NativeCurrency, Token } from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'
import invariant from 'tiny-invariant'

export const NATIVE_CHAIN_ID = 'NATIVE'

// When decimals are not specified for an ERC20 token
// use default ERC20 token decimals as specified here:
// https://docs.openzeppelin.com/contracts/3.x/erc20
export const DEFAULT_ERC20_DECIMALS = 18

export const USDC_CRAT = new Token(
  SupportedChainId.DUCX,
  '0xe5AB6881Fe3D22eCc213E5a56A9523a8576bD8D7',
  6,
  'USDC',
  'USD Coin'
)

/** DUCATUS-X SPECIFIC **/

/* virtual ducatus token */
export const USDDUC_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0xb1D1430bFAD24e6bed3F32A4560074f4c077Cac9',
  18,
  'vUsd-DUC',
  'Virtual USD-DUC'
)

/* virtual ducatus token */
export const USDDUCX_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0x73c8561399349809B5894cF12f371c911C42F798',
  18,
  'vUsd-DUCX',
  'Virtual USD-DUCX'
)

export const AAPLUS_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0x4272F8E9A2eEA6b853d40159Db33D662E5ca48dD',
  5,
  'AA+',
  'AA+'
)

export const GOLDMV_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0x6333bAD1632ae2a78CfC4aD4AEc6C99B1b54CdBD',
  18,
  'Gold MV',
  'Gold MV'
)

export const XGEN_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0x1c2d444E9828Ce1A01FDf506008207480b9475ED',
  18,
  'X-GEN',
  'X GEN TOKEN'
)

export const SHBT_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0xE95C65EB55D11D023A38296A0AaF658bAaB4B95e',
  5,
  'SHBT',
  'Spirit Hills Bali Token'
)

export const BULLION_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0x1405e2445C01361D4FbDf1DCBf7A9bd07810B530',
  18,
  'Bullion',
  'Bullion'
)

export const SHRES_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0x314e5d40a123F4Efdb096bB716767C905A7DcA97',
  5,
  'SHres',
  'Spirit Hills Reserve'
)

export const DUC_DUCX_TESTNET = new Token(
  SupportedChainId.DUCX_TESTNET,
  '0xe066196C3496c8A38BB9c488A7A240C840b71595',
  8,
  'DUC',
  'DUC'
)

// ducx mainnet

export const USDDUC_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0x845e4145F7de2822d16FE233Ecd0181c61f1d65F',
  18,
  'vUsd-DUC',
  'Virtual USD-DUC'
)

/* virtual ducatus token */
export const USDDUCX_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0x5Dc383A282E8Ed1280D781EE0547616a737e39B2',
  18,
  'vUsd-DUCX',
  'Virtual USD-DUCX'
)

export const AAPLUS_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0x986083CD47dBBC931585D2FE2330FD29B3e849b0',
  5,
  'AA+',
  'AA+'
)

export const GOLDMV_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0xcDdd562C0cF8c262AD8A5c1A476cdBBE114FcC28',
  18,
  'Gold MV',
  'Gold MV'
)

export const XGEN_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0x4860903C09F330613A2A3A3e05587176d6DF6B23',
  18,
  'X-GEN',
  'X GEN TOKEN'
)

export const SHBT_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0x0FB410280F80cf3f22Fc1Cf18Ea3bcca25aC0daE',
  5,
  'Shgen',
  'Spirit Hills Genesis'
)

export const BULLION_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0xD0A83Ff11CB82798933522dC8B7dB89d05995956',
  5,
  'BULT',
  'Bullion'
)

export const SHRES_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0x33a5f694bf84A9d003141956E7E20b95410bDf8d',
  5,
  'SHres',
  'Spirit Hills Reserve'
)

export const DUC_DUCX_MAINNET = new Token(
  SupportedChainId.DUCX,
  '0xC98983b0E68507EFebA531E4714419cd271114a1',
  8,
  'DUC',
  'DUC'
)

export const WRAPPED_NATIVE_CURRENCY: { [chainId: number]: Token | undefined } = {
  [SupportedChainId.DUCX]: new Token(
    SupportedChainId.DUCX,
    '0x391C62749D8093b9393A01a2cC149Be3B3896CCd',
    18,
    'WDUCX',
    'Wrapped DUCX'
  ),
  [SupportedChainId.DUCX_TESTNET]: new Token(
    SupportedChainId.DUCX_TESTNET,
    '0x72817E3d882B952b9bF04636Ba0e83F6477e5DA6',
    18,
    'WDUCX',
    'Wrapped DUCX'
  ),
}

function isDUCXTestnet(chainId: number): chainId is SupportedChainId.DUCX_TESTNET {
  return chainId === SupportedChainId.DUCX_TESTNET
}

function isDUCXMainnet(chainId: number): chainId is SupportedChainId.DUCX {
  return chainId === SupportedChainId.DUCX
}

class DucxTestnetNativeCurrency extends NativeCurrency {
  equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }

  get wrapped(): Token {
    if (!isDUCXTestnet(this.chainId)) throw new Error('Not DUCX testnet')
    const wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId]
    invariant(wrapped instanceof Token)
    return wrapped
  }

  public constructor(chainId: number) {
    if (!isDUCXTestnet(chainId)) throw new Error('Not DUCX testnet')
    super(chainId, 18, 'DUCX', 'DUCX')
  }
}

class DucxMainnetNativeCurrency extends NativeCurrency {
  equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }

  get wrapped(): Token {
    if (!isDUCXMainnet(this.chainId)) throw new Error('Not DUCX mainnet')
    const wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId]
    invariant(wrapped instanceof Token)
    return wrapped
  }

  public constructor(chainId: number) {
    if (!isDUCXMainnet(chainId)) throw new Error('Not DUCX mainnet')
    super(chainId, 18, 'DUCX', 'DUCX')
  }
}

class ExtendedEther extends Ether {
  public get wrapped(): Token {
    const wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId]
    if (wrapped) return wrapped
    throw new Error(`Unsupported chain ID: ${this.chainId}`)
  }

  private static _cachedExtendedEther: { [chainId: number]: NativeCurrency } = {}

  public static onChain(chainId: number): ExtendedEther {
    return this._cachedExtendedEther[chainId] ?? (this._cachedExtendedEther[chainId] = new ExtendedEther(chainId))
  }
}

const cachedNativeCurrency: { [chainId: number]: NativeCurrency | Token } = {}
export function nativeOnChain(chainId: number): NativeCurrency | Token {
  if (cachedNativeCurrency[chainId]) return cachedNativeCurrency[chainId]
  let nativeCurrency: NativeCurrency | Token

  if (isDUCXMainnet(chainId)) {
    nativeCurrency = new DucxMainnetNativeCurrency(chainId)
  } else if (isDUCXTestnet(chainId)) {
    nativeCurrency = new DucxTestnetNativeCurrency(chainId)
  } else {
    nativeCurrency = ExtendedEther.onChain(chainId)
  }
  return (cachedNativeCurrency[chainId] = nativeCurrency)
}

export const TOKEN_SHORTHANDS: { [shorthand: string]: { [chainId in SupportedChainId]?: string } } = {
  USDC: {},
}

/**
 * Hidden tokens - used for routing only, not visible in UI
 * Users cannot select, swap, or interact with these tokens directly
 */
export const HIDDEN_TOKEN_ADDRESSES: { [chainId: number]: Set<string> } = {
  [SupportedChainId.DUCX_TESTNET]: new Set([
    USDDUC_DUCX_TESTNET.address.toLowerCase(),
    USDDUCX_DUCX_TESTNET.address.toLowerCase(),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.DUCX_TESTNET]!.address.toLowerCase(),
    SHBT_DUCX_TESTNET.address.toLowerCase(),
  ]),
  [SupportedChainId.DUCX]: new Set([
    USDDUC_DUCX_MAINNET.address.toLowerCase(),
    USDDUCX_DUCX_MAINNET.address.toLowerCase(),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.DUCX]!.address.toLowerCase(),
    SHBT_DUCX_MAINNET.address.toLowerCase(),
  ]),
}
